import _ from "@lodash";
import XAPPService from "app/Core/services/XAPPService";
import { GETCUSTOM_TAG_FUNCIONALIDADE, TagFuncionalidadeListState } from "app/ERP/TagFuncionalidade/Store/Actions/TagFuncionalidadeActions";
export const GET_ARQUIVO = "[ARQUIVO APP] GET ARQUIVO";
export const GET_ARQUIVOS = "[ARQUIVO APP] GET ARQUIVOS";
export const GET_PASTAS = "[ARQUIVO APP] GET PASTAS";
export const OPEN_NEW_ARQUIVO_DIALOG = "[ARQUIVO APP] OPEN NEW ARQUIVO DIALOG";
export const CLOSE_NEW_ARQUIVO_DIALOG = "[ARQUIVO APP] CLOSE NEW ARQUIVO DIALOG";
export const OPEN_EDIT_ARQUIVO_DIALOG = "[ARQUIVO APP] OPEN EDIT ARQUIVO DIALOG";
export const CLOSE_EDIT_ARQUIVO_DIALOG = "[ARQUIVO APP] CLOSE EDIT ARQUIVO DIALOG";
export const ARQUIVO_REMOVE = "[ARQUIVO APP] ARQUIVO REMOVE";
export const ARQUIVO_WARNING = "[ARQUIVO APP] UPDATE ARQUIVO WARNING";
export const ARQUIVO_INFO_UPLOAD = "[ARQUIVO APP] UPDATE ARQUIVO INFO UPLOAD";
export const ARQUIVO_INFO = "[ARQUIVO APP] UPDATE ARQUIVO INFO";
export const ARQUIVO_ERROR_UPLOAD = "[ARQUIVO APP] UPDATE ARQUIVO ERROR UPLOAD";
export const ARQUIVO_ERROR = "[ARQUIVO APP] ARQUIVO ERROR";
export const ARQUIVO_IMAGE = "[ARQUIVO APP] ARQUIVO IMAGE";
export const ARQUIVO_DOWNLOAD = "[ARQUIVO APP] ARQUIVO DOWNLOAD";
export const SET_SELECTED_ARQUIVO = "[ARQUIVO APP] SET SELECED ARQUIVO";
export const ARQUIVO_CHANGE_PRELOAD = "[ARQUIVO APP] CHANGE PRELOAD";

export const ArquivoListState = [
    "idarquivo",
    "nome",
    "tipo",
    "idfuncionalidade",
    "pasta",
    "descricao",
    "caminho",
    "mimetype",
    "bucket",
    "tamanho",
    "compartilhar",
    "tags",
    "usrins",
    "usrupt",
    "datainsdescricao",
    "datauptdescricao",
];

const AddState = [
    "tipo",
    "pasta",
    "idpessoa",
    "nome",
    "descricao",
    "mimetype",
    "idfuncionalidade",
    "caminho",
    "bucket",
    "tamanho",
    "compartilhar"
];

export const ArquivoTagListState = [
    "idarquivotag",
    "idtag",
    "idtagpessoaformulario",
    "tagnome",
    "codigo",
];

export const PastaListState = [
    "tipo",
    "pasta",
    "nome",
];

export function list(_AAction, _AParams, _APasta, _AIDFuncionalidade = null, _AFilter = null) {

    return (dispatch) => {
        dispatch(changePreload());

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        if (!_.isNull(_APasta.pasta)) {
            AConditionsAND.push({ "Campo": "arquivo.pasta", "Operador": "=", "Valor": _APasta.pasta });
        }
        if (!_.isNull(_AIDFuncionalidade)) {
            AConditionsAND.push({ "Campo": "arquivo.idfuncionalidade", "Operador": "=", "Valor": _AIDFuncionalidade });
        }
        if (!_.isUndefined(_APasta.tipo) && !_.isNull(_APasta.tipo)) {
            AConditionsAND.push({ "Campo": "arquivo.tipo", "Operador": "=", "Valor": _APasta.tipo });
        }
        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }
        }
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Arquivo", AActions, "spvwarquivo", ArquivoListState, _AAction, AConditionsAND, AConditionsOR);

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Pasta", AActions, "spvwpasta", PastaListState, _AAction, AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_ARQUIVOS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    }),
                    dispatch({
                        type: GET_PASTAS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].data : "",
                    }),
                    dispatch(changePreload())
                ])
            )
            .catch(error => {
                return dispatch({
                    type: ARQUIVO_ERROR,
                    payload: error
                });
            });
    };
}

export function getTags(_AAction, _AParams) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AConditionsAND = [{ "Campo": "tagfuncionalidade.tipo", "Operador": "=", "Valor": "pessoa" }];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "tagfuncionalidade", AActions, "spvwtagfuncionalidade", TagFuncionalidadeListState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GETCUSTOM_TAG_FUNCIONALIDADE,
                        Name: "pessoa",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: ARQUIVO_ERROR,
                    payload: error
                });
            });
    };
}

export function get(_AAction, _AParams, _AID) {

    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idarquivo", "Operador": "=", "Valor": _AID }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Arquivo", AActions, "spvwarquivo", ArquivoListState, _AAction, AConditionsAND, AConditionsOR);
        //AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "arquivotag", AActions, "spvwarquivotag", ArquivoTagListState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_ARQUIVO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                    })
                    // , dispatch({
                    //     type: GET_FUNCIONALIDADE_TAG,
                    //     Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].name : "",
                    //     payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].data : "",
                    // })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: ARQUIVO_ERROR,
                    payload: error
                });
            });
    };
}

export function openNewDialog(_IsImage) {
    return {
        type: OPEN_NEW_ARQUIVO_DIALOG,
        isImage: _IsImage
    };
}

export function closeNewDialog() {
    return {
        type: CLOSE_NEW_ARQUIVO_DIALOG
    };
}

export function openEditDialog(data) {
    return {
        type: OPEN_EDIT_ARQUIVO_DIALOG,
        data: data
    };
}

export function closeEditDialog() {
    return {
        type: CLOSE_EDIT_ARQUIVO_DIALOG
    };
}

export function Error() {
    return {
        type: ARQUIVO_ERROR
    };
}

export function save(_AValue, _AParams, _ASelectedFile = null, _AResponse = null) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var AAction = "INSERIR";
        var obj = {};

        obj = { ..._AValue };
        obj.nome = _ASelectedFile.name;
        obj.file = _ASelectedFile.isImage === 1 ? _ASelectedFile.file64 : _ASelectedFile.file;
        obj.compartilhar = _ASelectedFile.compartilhar;
        obj.mimetype = _ASelectedFile.filetype;
        obj.caminho = _AResponse.caminho;
        obj.bucket = _AResponse.bucket;
        obj.tamanho = _AResponse.size;
        obj.descricao = _ASelectedFile.descricao;

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "arquivo", AAction, obj, "idarquivo", AConditionsAND, AConditionsOR, 1, AddState);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: ARQUIVO_WARNING,
                            payload: response.warning,
                            id: _ASelectedFile !== null ? response.ultimoidinserido : null,
                            nome: _ASelectedFile !== null ? _ASelectedFile.nome : null
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AValue, _AValue.idfuncionalidade)));
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: ARQUIVO_INFO_UPLOAD,
                            payload: response.info,
                            id: _ASelectedFile !== null ? response.ultimoidinserido : null,
                            nome: _ASelectedFile !== null ? _ASelectedFile.nome : null
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AValue, _AValue.idfuncionalidade)));
                }
            })
            .catch(error => {
                return dispatch({
                    type: ARQUIVO_ERROR_UPLOAD,
                    payload: error,
                    nome: _ASelectedFile !== null ? _ASelectedFile.nome : null
                });
            });
    };
}

export function update(_AValue, _AParams) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var AAction = "ATUALIZAR";
        var obj = {};

        AConditionsAND = [{ "Campo": "idarquivo", "Operador": "=", "Valor": _AValue.idarquivo }];
        obj = { descricao: _AValue.descricao, compartilhar: _AValue.compartilhar };

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "arquivo", AAction, obj, "idarquivo", AConditionsAND, AConditionsOR, 1, ["descricao", "compartilhar"]);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: ARQUIVO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AValue, _AValue.idfuncionalidade)));
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: ARQUIVO_INFO,
                            payload: response.info
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AValue, _AValue.idfuncionalidade)));
                }
            })
            .catch(error => {
                return dispatch({
                    type: ARQUIVO_ERROR,
                    payload: error
                });
            });
    };
}

export function remove(_AValue, _AParams) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idarquivo", "Operador": "=", "Valor": _AValue.idarquivo }];
        var AConditionsOR = [];
        var AActions = [];

        _AValue.statusregistro = -1;

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "arquivo", "INATIVAR", _AValue, "", AConditionsAND, AConditionsOR, 1, ["statusregistro"]);
        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: ARQUIVO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AValue, _AValue.idfuncionalidade)));
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: ARQUIVO_INFO,
                            payload: response.info
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AValue, _AValue.idfuncionalidade)));
                }
            })
            .catch(error => {
                return dispatch({
                    type: ARQUIVO_ERROR,
                    payload: error
                });
            });
    };
}

export function uploadFile(_ASelectedFile, _AParams, _AState, _AIDEmpresa) {
    return (dispatch) => {
        var formData = new FormData();
        formData.append("name", _ASelectedFile.name);
        formData.append("path", _ASelectedFile.nome);
        formData.append("empresa", _AIDEmpresa);
        if (_ASelectedFile.file !== null) {
            formData.append("filetype", _ASelectedFile.file.type);
            formData.append("arquivo", _ASelectedFile.file);
        }
        else if (_ASelectedFile.file64 !== null) {
            formData.append("filetype", _ASelectedFile.filetype);
            formData.append("arquivo64", _ASelectedFile.file64);
        }

        XAPPService.XappUploadFileAction(formData, "arquivo")
            .then((response) => {
                if (response.data) {
                    var AResponse = { "bucket": response.data.bucket, "size": response.data.size, "caminho": response.data.caminho };
                    Promise.all([
                        dispatch(save(_AState, _AParams, _ASelectedFile, AResponse))
                    ]);
                }
            })
            .catch(error => {
                return dispatch({
                    type: ARQUIVO_ERROR_UPLOAD,
                    payload: error,
                    nome: _ASelectedFile !== null ? _ASelectedFile.nome : null
                });
            });
    };
}

export function clearArquivo() {
    return (dispatch) => {
        Promise.all([
            dispatch(
                {
                    type: GET_ARQUIVOS,
                    payload: null
                }),
            dispatch(
                {
                    type: SET_SELECTED_ARQUIVO,
                    payload: null
                })
        ]);
    };
}

export function downloadFile(_AState, _AIDEmpresa) {
    return (dispatch) => {

        XAPPService.XappDownloadFileAction(_AState.nome, _AState.caminho, _AIDEmpresa, _AState.mimetype)
            .then((response) => {
                if (response.data) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", _AState.nome);
                    document.body.appendChild(link);
                    link.click();

                }
            })
            .catch(error => {
                return dispatch({
                    type: ARQUIVO_ERROR,
                    payload: error
                });
            });
    };
}

export function previewFile(_AState, _AIDEmpresa) {
    return (dispatch, getState) => {
        dispatch(changePreload());
        XAPPService.XappDownloadFileAction(_AState.nome, _AState.caminho, _AIDEmpresa, _AState.mimetype)
            .then((response) => {
                if (response.data) {
                    const url = window.URL.createObjectURL(response.data);
                    Promise.all([
                        dispatch({
                            type: OPEN_EDIT_ARQUIVO_DIALOG,
                            data: { ...getState().Arquivo.arquivoDialog.data, url }
                        }),
                        dispatch(changePreload())
                    ]);
                }
            })
            .catch(error => {
                Promise.all([
                    dispatch(changePreload()),
                    dispatch({ type: ARQUIVO_ERROR, payload: error })
                ]);
            });
    };
}

export function removePreviewFile() {
    return (dispatch, getState) => {
        return dispatch({
            type: OPEN_EDIT_ARQUIVO_DIALOG,
            data: { ...getState().Arquivo.arquivoDialog.data, url: null }
        });
    }
};

export function getImage(_AIDArquivo, _AParams, _AIsThumb) {
    return (dispatch) => {
        if (_AIsThumb === "0") {
            dispatch({ type: ARQUIVO_DOWNLOAD, id: _AIDArquivo });
        }
        XAPPService.XappFile64Action(_AParams.empresa, _AIDArquivo, _AIsThumb)
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: ARQUIVO_IMAGE,
                        payload: response.data,
                        id: _AIDArquivo,
                        isThumb: _AIsThumb
                    });
                    if (_AIsThumb === "0") {
                        dispatch(setSelected(_AIDArquivo));
                    }
                }
            })
            .catch(error => {
                return dispatch({
                    type: ARQUIVO_ERROR,
                    payload: error
                });
            });
    };
}

export function setSelected(_AIDArquivo) {
    return {
        type: SET_SELECTED_ARQUIVO,
        payload: _AIDArquivo
    };
}

function changePreload() {
    return {
        type: ARQUIVO_CHANGE_PRELOAD
    };
}